module.exports = __webpack_public_path__ + "img/2.254f33bc.png";